// extracted by mini-css-extract-plugin
export default {"todoList":"Todolist_todoList__2XFg-"};